import { Component, OnInit } from '@angular/core';
import { BRAND_CONFIG } from '../brand.config';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  brand = BRAND_CONFIG;
  currentYear = new Date().getFullYear();

  constructor() {}

  ngOnInit() {}
}
